<script lang="ts" setup>
	import type { TravelDataContext } from '~/stores/products/types'

	defineProps<{
		productCategory: string
		productName: string
	}>()
	const { getBenefits } = useContentApis()
	const benefits = await resolve(() =>
		getBenefits<TravelDataContext | null>({ category: 'travel', group_id: 'travel' })
	)
	const productBenefit = computed(() => {
		return benefits?.value?.data ?? null
	})
</script>

<template>
	<div>
		<table v-if="productBenefit" class="w-full">
			<thead>
				<th
					v-for="(item, index) in productBenefit.headers"
					:key="`thData-${index}`"
					:class="[
						item.ui,
						'min-h-[100px] min-w-[120px] text-center sticky top-0 left-0 p-[22px_14px_22px_20px] border-r last:border-r-0 '
					]"
				>
					{{ item.text }}
				</th>
			</thead>

			<tbody>
				<tr v-for="(trData, trIndex) in productBenefit.rows" :key="'tr-data-' + trIndex">
					<td
						v-for="(tdData, index) in productBenefit.headers"
						:key="`tData-${index}`"
						:class="[
							trData[tdData.key].ui,
							'p-5 border',
							{ 'text-gray-700': index === 0, 'text-gray-600': index !== 0 }
						]"
					>
						<span>{{ trData[tdData.key].text }}</span>
					</td>
				</tr>
			</tbody>
		</table>
		<p class="font-medium text-gray-700 sm:leading-[24px] py-8">
			<span class="font-semibold"> Schengen Countries: </span> Austria, Belgium, Czech Republic, Denmark, Estonia,
			Finland, France, Germany, Greece, Hungary, Iceland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherland,
			Norway, Poland, Portugal, Slovenia, Spain, Sweden, Switzerland, Liechtenstein.
		</p>
	</div>
</template>

<style></style>
